import Swiper, { Navigation, Pagination } from "swiper";
import { on } from '../helpers/utils';

const selectors = {
  mainTarget: '.product-main__slider',
  navTarget: '.product-main__slider-nav',
  zoom: '[js-zoom="container"]',
};

export default () => {
  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    zoom: document.querySelectorAll(selectors.zoom),
  };

  function sliderRender() {
    const mainTarget = selectors.mainTarget;
    const navTarget = selectors.navTarget;
    const mainTargetNode = document.querySelector(mainTarget);

    if (!mainTargetNode) { return }

    const initSlide = parseInt(
      mainTargetNode.dataset.swiperInitialslide
    );

    const initial = initSlide === null ? 10 : initSlide;
    console.log('👉 Initial Slide: ' + initial);

    Swiper.use([Navigation, Pagination]);

    const thumbsSlider = new Swiper(navTarget, {
      slidesPerView: 4,
      zoom: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      spaceBetween: 16,
    });

    const mainSlider = new Swiper(mainTarget, {
      slidesPerView: 1,
      loop: true,
      zoom: true,
      initialSlide: initial,
      navigation: {
        nextEl: '.swiper-button-next--main-slider',
        prevEl: '.swiper-button-prev--main-slider',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: 'true',
      },
      thumbs: {
        swiper: thumbsSlider,
      },
    });
  }

  function init() {
    sliderRender();
    setBusListeners();
    setEvenListeners();
  }

  function setBusListeners() {
    Karmoon.EventBus.listen(
      ['ProductForm:change'],
      (data) => {
        updateSlide(data.currentVariant.id)
      }
    );
  }

  function setEvenListeners() {
    if (theme.product.productZoom !== true) {
      return false;
    }

    console.log(`🔍 Zoom: Loaded`)

    nodeSelectors.zoom.forEach((item) => {
      on('mousemove', item, (event) => zoom(event));
    });
  }

  function zoom(event){
    let zoomer = event.currentTarget;
    let offsetX = event.offsetX ? offsetX = event.offsetX : offsetX = event.touches[0].pageX
    let offsetY = event.offsetY ? offsetY = event.offsetY : offsetX = event.touches[0].pageX
    let x = offsetX/zoomer.offsetWidth*100
    let y = offsetY/zoomer.offsetHeight*100
    zoomer.style.backgroundPosition = x + '% ' + y + '%';
  }

  function updateSlide(variant) {
    const variantId = `[data-variant-id="${variant}"`;
    const currentVariantSlide = document.querySelector(variantId);
    if (!currentVariantSlide) {return};

    const currentSlide = parseInt(currentVariantSlide.dataset.swiperSlideIndex) + 1;
    const target = selectors.mainTarget;
    const swiper = document.querySelector(target).swiper;
    swiper.slideTo(currentSlide, 1000, false);

    console.log(`👉 Slide to image: ${currentSlide}`)
    console.log(`🤠 Variant ID: ${variant}`)
  }

  /**
   * Public interface.
   */
  return Object.freeze({
    init,
  });
};
